function language(lang) {
    let tmp
    switch(lang) {
        case 'ja':
        case 'ja-JP':
        tmp = "ja"
        break;
        default:
        tmp = "en"
    }
    return tmp
}

const messages = {
    "en": require('./translate/en.json'),
    "ja": require('./translate/ja.json')
}

export {
    language,
    messages
}
